<template>
    <div id="app">
        <el-container>
            <el-header v-show="!isLogin">
                <div class="header">
                    <div class="title">
                        <div>爱疯验证后台管理系统</div>
                    </div>
                    <div class="user">
                        <el-dropdown @command="handelDrop">
                            <div class="el-dropdown-link">
                                {{getAccount || 'unKnown'}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="signOut">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-header>
            <el-main :style="{'padding':isLogin? 0:'10px 10px 0 10px'}">
                <router-view class="transitionBody isManage"></router-view>
            </el-main>
            <div class="filing">
                <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022062041号-1</a>
            </div>
        </el-container>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    // import { saveState } from '@/assets/js/utils'
    export default {
        name: 'App',
        data() {
            return {
                activeMenuIndex: '',
                breadList: []
            }
        },
        watch: {
            $route() {
                this.activeMenuIndex = this.$route.path
                this.getBreadcrumbList()
            }
        },
        computed: {
            ...mapGetters(['getAccount']),
            routes() {
                return this.$router.options.routes.filter(item => item.meta)
            },
            isLogin() {
                return this.$route.path === '/login'
            },
            isHome() {
                return this.$route.path === '/home'
            },
        },
        mounted() {
            this.activeMenuIndex = this.$route.path
        },
        methods: {
            handelDrop(val) {
                if (val === 'signOut') {
                    sessionStorage.removeItem('token')
                    this.$router.replace({ path: '/login' })
                }
            },
            getBreadcrumbList() {
                this.breadList = this.$route.matched.filter(item => item.name)
            }
        }
    }
</script>

<style lang="less" scoped>
    #app {
        font-family: Microsoft YaHei, Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: 100vh;
        background-color: #f6faff;
        .filing {
            position: absolute;
            bottom: 0;
            text-align: center;
            height: 30px;
            width: 100%;
            a {
                color: #b9b9b9;
                line-height: 30px;
                font-size: 12px;
            }
        }
        .title {
            height: 60px;
            float: left;
            display: flex;
            flex-direction: column;
            justify-content: center;
            & > div {
                font-size: 20px;
                height: 20px;
                font-weight: bold;
                padding: 0 20px;
                margin-right: 30px;
                color: #e6f6f7;
                text-shadow: 0 0 2px #6e8898;
            }
            // background: -webkit-linear-gradient(
            //     #9fb1bc 0%,
            //     #9fb1bc 30%,
            //     #2e5266 100%
            // );
            // background-clip: text;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
        }
        .user {
            float: right;
            margin-right: 50px;
            height: 60px;
            .el-dropdown-link {
                color: #e6f6f7;
                line-height: 60px;
                cursor: pointer;
            }
        }
        /deep/ .el-header {
            background-color: #2e5266;
        }
        /deep/ .el-main {
            box-sizing: border-box;
            .transitionBody {
                height: calc(100vh - 100px);
                padding: 20px;
                box-sizing: border-box;
                // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            }
            .isManage {
                background-color: #fff;
                border-radius: 3px;
                border: 1px solid #ebeef5;
            }
        }
    }
</style>
